import * as STD          from '@emersya/mpa-std-lib';
import CM                from '@emersya/mpa-components-manager-lib';

export interface IModalsZoneComponentConfiguration extends CM.DOMComponent.IConfiguration {
};

export class ModalsZoneComponent extends CM.DOMComponent<
	HTMLDivElement,
	ModalsZoneComponent,
	IModalsZoneComponentConfiguration
>
{
	component_DOM : HTMLDivElement;

	readonly modalsStack : ModalNS.Component[] = [];

	async useModal<TData>(idOrComponent : string | ModalNS.Component, data : TData) {
		const modal = (typeof idOrComponent !== 'string') ? idOrComponent : (() => {
			const component = <ModalNS.Component> this.component_outerChilds.find(x => x.id === idOrComponent);
			if (!component) {
				this.component_throwUserError('Unable to find modal with this id');
			}
			return component;
		})();
		// enable modal
		if (!modal.component_isDisabled) {
			this.component_throwUserError('');
		}
		CM.root.component_DOM.classList.add('usingModal');
		await modal.component_enable();
		// add modal to stack
		this.modalsStack.push(modal);
		// add z-index according to index in stack
		modal.component_DOM.style.zIndex = (this.modalsStack.length + 1).toString();
		// call use() of the component with specific parameters when needed
		await modal.use(data);
		if (this.modalsStack.slice(-1)[ 0 ] !== modal) {
			this.component_throwLibraryError('');
		}
		this.modalsStack.pop();
		await modal.component_disable();
		if (!this.modalsStack.length) {
			CM.root.component_DOM.classList.remove('usingModal');
		}
	};

	async tryUseModal<TData>(idOrComponent : string | ModalNS.Component, data : TData) {
		if (typeof idOrComponent === 'string') {
			const component = <ModalNS.Component> this.component_outerChilds.find(x => x.id === idOrComponent);
			if (!component) {
				this.component_throwUserError('Unable to find modal with this id')
			}
			idOrComponent = component;
		}
		if (idOrComponent.component_isDisabled) {
			await this.useModal(idOrComponent, data);
		}
	};

	override async component_appendOuterChild(
		component : CM.Component<any, any>,
		_slot : string | HTMLElement
	) : Promise<void> {
		if (!(component instanceof ModalNS.Component)) {
			this.component_throwUserError('Child is not instance of modal', { child : component });
		}
		if (this.component_isStarted && !component.component_isDisabled) {
			await component.component_disable();
		}
		await super.component_appendOuterChild(component, _slot);
	};

	override async component_start(ev : STD.events.Event<any, CM.Component<any, any>, any>) : Promise<void> {
		await super.component_start(ev);
		for (const c of this.component_outerChilds) {
			if (!c.component_isDisabled) {
				await c.component_disable();
			}
		}
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IModalsZoneComponentConfiguration
	)
	{
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory();
	};
};
export namespace NS {
	export const Component = ModalsZoneComponent;
	export type Component = ModalsZoneComponent;
	export type Configuration = IModalsZoneComponentConfiguration;
}
import manifestXMLSource from './ModalsZone.xml';
import './ModalsZone.scss';

CM.declare({
	id :       'modalsZone',
	type :     ModalsZoneComponent,
	manifest : manifestXMLSource
});
import { NS as ModalNS } from '../Modal/Modal';